export default "__VITE_ASSET__BCjusL2E__"